import { login } from '@/api/login'
import { getToken, setToken, removeToken, getUserid, setUserid, removeUserid } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    userid: getUserid()
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERID: (state, userid) => {
      state.userid = userid
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      console.log(userInfo);
      userInfo.userName = userInfo.userName.trim()
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          const tokenStr = response.data.token
          const useridStr = response.data.userid
          setToken(tokenStr)
          setUserid(useridStr)
          commit('SET_TOKEN', tokenStr)
          commit('SET_USERID', useridStr)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  } 
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js